import log from 'salvo-lite/log'
import axios from 'axios'

class BlogFilters {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._blog = elem.getAttribute('data-blog-filter')
        this._filters = elem.querySelectorAll('[data-filter]')

        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this._filters.forEach(filter => {
            filter.addEventListener('click', () => {
                this._filters.forEach(filter => {
                    filter.classList.remove('underline')
                })

                filter.classList.add('underline')

                this.ajaxBlog(filter.getAttribute('data-filter'))
            })
        })
    }

    async ajaxBlog (filter) {
        let url

        if (filter === 'all') {
            url = '/blogs/' + this._blog

            this._filters.forEach(filter => {
                if (filter.getAttribute('data-filter') === 'all') {
                    filter.classList.add('underline')
                } else {
                    filter.classList.remove('underline')
                }
            })
        } else {
            url = '/blogs/' + this._blog + '/tagged/' + filter
        }
        const blogPostsContainer = document.querySelector('section.blog')

        try {
            const res = await axios.get(url)

            const div = document.createElement('div')
            div.innerHTML = res.data

            const newData = div.querySelector('section.blog').innerHTML

            blogPostsContainer.innerHTML = newData

            this._theme.registerComponents()
        } catch (err) {
            document.querySelectorAll('.article-item').forEach(item => {
                blogPostsContainer.removeChild(item)
            })

            const noBlogsText = document.querySelector('.no-blogs-text')

            noBlogsText.classList.add('active')

            blogPostsContainer.querySelector('#return').addEventListener('click', () => {
                this.ajaxBlog('all')
            })
        }
    }
}

export default BlogFilters



// WEBPACK FOOTER //
// ./src/resources/scripts/components/BlogFilter.js